/**
 * Points absolute links to the backend's storage in CMS HTML (`https://<api>/storage/…`) to the storefront's own
 * `/storage/…`, which `app/storage/[...path]/route.ts` serves from the same files.
 */
export function localizeStorageUrls(html: string): string {
    const storageBaseUrl = process.env.NEXT_PUBLIC_STORAGE_BASE_URL;

    if (!storageBaseUrl) {
        return html;
    }
    return html.replaceAll(`${storageBaseUrl.replace(/\/+$/, '')}/storage/`, '/storage/');
}
